import { withStyles } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
    margin: "6px 0px 6px",
  },
  labelContainer: {
    display: "flex",
    marginRight: 14,
  },
  label: {
    color: theme.iconColor,
    fontWeight: 400,
    lineHeight: "16px",
  },
  valueContainer: {
    display: "flex",
    marginRight: 22,
  },
  value: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 600,
    lineHeight: "16px",
  },
  dividerStyle: {
    borderRight: `1px solid ${theme.HeaderSelectedText}`,
    margin: "1 6 0 6",
    opacity: 0.5,
    borderWidth: "0.1px"
  },
});
const DetailsList = ({ classes, labels = [], values = [] }) => {
  if (!labels || !values) {
    return;
  }
  const lastLabel = labels.length - 1;
  const lastValue = values.length - 1;
  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        {labels.map((label, index) => (
          <React.Fragment key={`label-${index}`}>
            <span className={classes.label}>{label}</span>
            {index !== lastLabel && <span className={classes.dividerStyle}/>}
          </React.Fragment>
        ))}
      </div>
      <div className={classes.valueContainer}>
        {values.map((value, index) => (
          <React.Fragment key={`value-${index}`}>
            <span className={classes.value}>
              {value}
            </span>
            {index !== lastValue && <span className={classes.dividerStyle}/>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
export default withStyles(styles)(DetailsList);
